import {
  IOnboardingTemplateActivityPure,
  IOnboardingTemplateChapterPure,
  OnboardingChapterType,
  OnboardingContactType,
} from './OnboardingTemplates'

export enum OnboardingInstanceStatus {
  DRAFT = 'draft',
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}

export enum OnboardingInstanceActivityStatus {
  NOT_STARTED = 'not_started',
  COMPLETED = 'completed',
  SKIPPED = 'skipped',
}

export enum OnboardingProgressStatus {
  NOT_STARTED_YET = 'not_started_yet',
  FINISHED = 'finished',
  FAR_BEHIND = 'far_behind',
  BEHIND_SCHEDULE = 'behind_schedule',
  ON_SCHEDULE = 'on_schedule',
  AHEAD_OF_SCHEDULE = 'ahead_of_schedule',
  FAR_AHEAD = 'far_ahead',
}

export interface IOnboardingInstancePure {
  _id?: any
  companyId: string
  memberId: string
  templateId: string
  durationInDays: number
  dateCompleted?: Date
  storylineComplete: {
    office: boolean
    culture: boolean
    skills: boolean
  }
  chapters: Array<{
    chapterId: string
    isLocked: boolean
    activities: IOnboardingInstanceActivitiesPure[]
  }>
  status: OnboardingInstanceStatus
  onboardingBuddyId: string
  dateCreated: Date
  startingDate: Date
  emailsSent: {
    lastOnboardingProgressEmail: Date
    onboardingCompleteEmail: boolean
    onboardingStartedEmail: boolean
    onboardingWelcomeTeamEmail: boolean
  }
}

export interface IOnboardingInstanceActivitiesPure {
  activityId: string
  contactId?: string
  contactType?: OnboardingContactType
  status: OnboardingInstanceActivityStatus
  _id?: any
  lastModified?: Date
}

export interface ICreateOnboardingInstance {
  memberId: string
  onboardingBuddyId: string
  templateId: string
  durationInDays: number
  startingDate: Date
  chapters: IOnboardingInstancePure['chapters']
}

export type IActiveOnboarding = Omit<IOnboardingInstancePure, 'chapters'> & {
  progressStatus: OnboardingProgressStatus
}
export interface ICompanyOnboardingInstancesOverview {
  activeOnboardings: IActiveOnboarding[]
  recentlyOnboarded: Array<{
    memberId: string
    onboardingId: string
  }>
}

export interface IOnboardingInstanceActivities {
  totalActivities: number
  completedActivities: number
  skippedActivities: number
}

export interface IOnboardedInstanceHighlights {
  onboardingId?: string
  memberId: string
  buddyId: string
  journeyName: string
  activities: IOnboardingInstanceActivities
  plannedDurationInDays: number
  actualDurationInDays?: number
  startingDate?: Date
}

export interface IOnboardedInstancePreviewActivity {
  activityId: string
  activityTitle: string
  contactType: OnboardingContactType
  contactId?: string
  status: OnboardingInstanceActivityStatus
}

export interface IOnboardedInstancePreview {
  chapterId: string
  chapterType: OnboardingChapterType
  isLocked: boolean
  chapterName: string
  activities: IOnboardedInstancePreviewActivity[]
}

export type IOnboardingInstancePopulatedActivity = IOnboardingTemplateActivityPure &
  IOnboardingInstanceActivitiesPure

export type IOnboardingInstancePopulated = Omit<
  IOnboardingInstancePure,
  'chapters'
> & {
  chapters: Array<
    Omit<IOnboardingTemplateChapterPure, 'activities'> & {
      isLocked: boolean
      activities: IOnboardingInstancePopulatedActivity[]
    }
  >
}
